<template>
	<div>
		
		<div  style="width: 100%;height: 350px;background-color: #0F0B26;color: white;">
			<div style="color:white;text-align: center;background-color: #0F0B26;font-weight: 800;">今日停车</div>
			<div style="display: flex;text-align: center;margin: 20px 0;justify-content: space-between;">
				<div style="width: 49%;padding: 10px;font-size: 30px;background-color: #00A8FB;">今日进场车辆{{list.今日入住}}</div>
				<div style="width: 49%;padding: 10px;font-size: 30px;background-color: #FCB300;">今日出场车辆{{list.本月入住}}</div>
			</div>
			<div style="display: flex;justify-content: center;">
				<div style="display: flex;width: 50%">
					<div id="tb4" style="width: 60%;height: 220px;">
						
					</div>
					<div style="width: 40%;height: 220px;display: flex;align-items: center;">
						<div>
							<div>剩余车位:</div>
							<div style="margin: 10px 0;">临停车:</div>
							<div>免费车:</div>
						</div>
					</div>
				</div>
				<div style="display: flex;width: 50%">
					<div id="tb5" style="width: 60%;height: 220px;">
						
					</div>
					<div style="width: 40%;height: 220px;display: flex;align-items: center;">
						<div>
							<div>停车费:</div>
							<div style="margin: 10px 0;">移动支付:</div>
							<div style="margin-bottom: 10px;">商家优惠:</div>
							<div>积分抵扣:</div>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>
</template>

<script>
	export default {
	
		data() {
			return {
				list:{}
			}
		},
		mounted() {
			this.getJrqk()
			this.getZX()
		},
		methods: {
			getZX() {
				let myChart = this.echarts.init(document.getElementById('tb5'), 'dark');
				setTimeout(() => {
					this.$http.get("/api/checkInApply/countTalentByLevel").then(res => {
						let data = [{
								value: res.data.data.undergraduate,
								name: "移动支付"
							},
							{
								value: res.data.data.master,
								name: "商家优惠",
							},
							{
								value: res.data.data.master,
								name: "积分抵扣",
							},
						];
						let option = {
							backgroundColor: '#0F0B26',
						
							tooltip: {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c}"
							},
							color:['#00ffff', '#02a7f0'],
						
							series: [{
								name: '费用',
								type: 'pie',
								radius: '50%',
								data: data,
								avoidLabelOverlap: true, //图饼标签false重复
								emphasis: {
									itemStyle: {
										shadowBlur: 10,
										shadowOffsetX: 0,
										shadowColor: 'rgba(0, 0, 0, 0.5)'
									}
								},
								itemStyle: {
									normal: {
										label: {
											show: true,
											formatter: '{b} : {c} '
										},
										labelLine: {
											show: true
										}
									},
								}
							}]
						}
						myChart.setOption(option);
					})
				}, 100)
			},
			getJrqk() {
				let myChart = this.echarts.init(document.getElementById('tb4'), 'dark');
				setTimeout(() => {
					this.$http.get("/api/roomManage/countRoom").then(res => {
						console.log("客房数", res);
						this.sum = res.data.data.sum;
						this.free = res.data.data.free;
						this.maintain = res.data.data.maintain;
						this.toBeCheckIn = res.data.data.toBeCheckIn;
						this.checkedIn = res.data.data.checkedIn;
					
						let data = [{
								value: this.free,
								name: "空闲中"
							},
							{
								value: this.maintain,
								name: "维护中",
							}
						];
						let option = {
							backgroundColor: '#0F0B26',
							// title: {
							// 	text: '客房详情'
							// },
							tooltip: {
								trigger: 'item',
								formatter: "{a} <br/>{b} : {c}"
							},
							// legend: {
							// 	x: 'center',
							// 	y: 'bottom',
							// 	data: ['待入住', '空闲中', '已入住', '维护中']
							// },
							color:['#D9001B', '#00FFFF'],
							series: [{
								name: '车辆使用率',
								type: 'pie',
								radius: ['40%', '70%'],
								data: data,
								emphasis: {
									label: {
										show: true,
										fontSize: '20',
										fontWeight: 'bold'
									}
								},
					
								itemStyle: {
									normal: {
										label: {
											show: true,
											formatter: '{b} : {c} '
										},
									},
								}
							}]
						}
						myChart.setOption(option)
					
					})
				}, 100)
			}
		}
	}
</script>

<style scoped="scoped">
</style>
